import moment from "moment";

export const STATUSES = {
    FETCHING: 'FETCHING',
    FETCHED: 'FETCHED',
    SAVING: 'SAVING',
    SAVED: 'SAVED',
    ERROR: 'ERROR',
    IDLE: 'IDLE',
}

export const VISIBLE_STEPS = [
    { step: 1, order: 1 },
    { step: 2, order: 1 },
    { step: 3, order: 1 },
    { step: 4, order: 1 },
];

// SUMARY

export const CARD_DETAILS_TEMPLATE = [
    {
        id: 'originAccount',
        label: 'transfer_account-transfer_account_from_another_bank_step1_summary_origin_account',
        type: 'single',
        format_type: '',
        order: 1,
        visible: VISIBLE_STEPS,
    },
    {
        id: 'entity',
        label: 'transfer_account-transfer_account_from_another_bank_step1_summary_origin_entity',
        type: 'single',
        format_type: '',
        order: 2,
        visible: VISIBLE_STEPS,
    },
    {
        id: 'applicationDate',
        label: 'transfer_account-transfer_account_from_another_bank_step1_summary_execution_date',
        type: 'single',
        order: 3,
        format_type: '',
        visible: VISIBLE_STEPS,
    },
    {
        type: 'separator',
        order: 4,
        visible: VISIBLE_STEPS
    },
    {
        id: 'openbankAccount',
        label: 'transfer_account-transfer_account_from_another_bank_step1_summary_destination_account',
        type: 'single',
        format_type: '',
        order: 5,
        visible: VISIBLE_STEPS
    }
];

export const LOCAL_STATE = {
    card_details_title: "transfer_account-transfer_account_from_another_bank_step1_summary_title",
    checkUserIsCollective: false,
}

// STEP 1

const MIN_START_IN_DAYS = 13
const DEFAULT_DATE_IN_DAYS = 30

export const MIN_DATE = moment().add(MIN_START_IN_DAYS, 'days');
export const DEFAULT_DATE = moment().add(DEFAULT_DATE_IN_DAYS, 'days');

// STEP 3
export const AUTHORISE_REQUEST = "requestsOriginBank1"
export const AUTHORISE_STEPS = "requestsOriginBank2"

export const TOOLTIP_TEXT_MODAL = {
    [AUTHORISE_REQUEST]: {
        title: 'transfer_account-transfer_account_from_another_bank_step3_tooltip_text',
        descriptionPartOne: 'transfer_account-transfer_account_from_another_bank_step3_tooltip_description1',
        descriptionPartTwo: 'transfer_account-transfer_account_from_another_bank_step3_tooltip_description2',
        descriptionPartThree: 'transfer_account-transfer_account_from_another_bank_step3_tooltip_description3',
    },
    [AUTHORISE_STEPS]: {
        title: 'transfer_account-transfer_account_from_another_bank_step3_tooltip1_text',
        descriptionPartOne: 'transfer_account-transfer_account_from_another_bank_step3_tooltip1_description1',
        descriptionPartTwo: 'transfer_account-transfer_account_from_another_bank_step3_tooltip1_description2',
    }
}

const TRANSFER_ACCOUNT = 'transfer_account'

export const CHECKBOX_AUTHORIZATION = {
    [AUTHORISE_REQUEST]: [
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox1_first_option`,
            name: 'validationCheck1',
        },
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox1_second_option`,
            name: 'validationCheck2',
        },
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox1_third_option`,
            name: 'validationCheck3',
        },
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox1_fourth_option`,
            name: 'validationCheck4',
        }
    ],
    [AUTHORISE_STEPS]: [
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox2_first_option`,
            name: 'validationCheck5',
        },
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox2_second_option`,
            name: 'validationCheck6',
        },
        {
            label: `${TRANSFER_ACCOUNT}-transfer_account_from_another_bank_step3_checkbox2_third_option`,
            name: 'validationCheck7',
        }
    ]
}